document.addEventListener('DOMContentLoaded', function (event) {
  setTimeout(() => {
    let temp = window.location.hostname
    if (temp.indexOf('fr') > -1) {
      let customerTag = document.querySelectorAll(`#customer-tag`)
      if (customerTag) {
        customerTag.forEach(tag => {
          temp = tag.value
          temp = temp.replace('#wgen#wg', '#wgfr#wg')
          tag.value = temp
        })
      }
    }
  }, 500)
})

//Weglot
document.addEventListener('DOMContentLoaded', weglotSetup, false)

function weglotSetup() {
  const weglot = window.Weglot

  if (weglot) {
    document.querySelector('.weglot-container') ? weglotInit() : setTimeout(weglotInit, 1000)
    setTimeout(() => {
      let weglotUrlSearchParams = new URLSearchParams(window.location.search)
      let weglotParams = Object.fromEntries(weglotUrlSearchParams.entries())
      if (weglotParams && weglotParams.fr) {
        const newLang = (weglotParams.fr == '1') ? 'fr' : 'en'
        let temp = document.querySelector(`.lang-selector [data-value="${newLang}"]`)
        if (temp) { temp.click() }
      }
    }, 2000)
  }
}

function openGeoloc() {
  document.querySelector('.geoloc').style.display = ''
}

function weglotInit() {
  const weglot = window.Weglot
  document.querySelector('.weglot-container')
    ? document.querySelector('.weglot-container').style.display = 'none'
    : ''

  // setTimeout(() => {
  //   const currentLang = window.Weglot.getCurrentLang()
  //   document.querySelector('.current_lang').innerHTML = currentLang ? currentLang.toUpperCase() : 'EN'
  // },1000)

  const languages = []
  languages.push(weglot.options.language_from)
  weglot.options.languages.forEach( lang => languages.push(lang.language_to))
  const langSelector = document.querySelectorAll('.lang-selector')
  let optionsContent = ''
  languages.forEach(lang => {
    if (lang === 'en') {
      optionsContent += `<span data-value="${lang}">EN</span> <span style="opacity: 0.3">|</span>`
    } else {
      optionsContent += `<span data-value="${lang}">&nbsp;FR</span>`
    }
  })
  langSelector.forEach(elem => {
    elem.innerHTML = optionsContent
    elem.value = weglot.getCurrentLang()
    elem.addEventListener('click', function(event) {
      weglot.switchTo(event.target.dataset.value)
    })
  })
}

// CART FUNCTIONALITY
function closeCart() {
  document.dispatchEvent(new Event('cart:close'))
}

function addToCart(variantId, quantity) {
  const data = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 422 || data.status === 'bad_request') {
    } else {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'))

      const El = document.querySelector('.cart__scrollable')
      El.scrollTo({ top: 0, behavior: 'smooth' })
    }
  })
}

function deleteBundleFromCart (keyArray) {
  let addData = {
    updates: {}
  }

  let aux = keyArray.split(',')
  aux.forEach(key => {
    let temp = key.split('=')
    addData.updates[temp[0]] = 0
  })

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(addData)
  })
    .then((response) => {
      if (response.status === 200) {
        document.dispatchEvent(new Event('cart:build'))
      }
    })
    .catch((error) => {
      console.log('catch: deleteBundleFromCart', error)
    fetch(`${routes.cart_change_url}`, config)
  .then((response) => response.text())
  .then((state) => {
    const parsedState = JSON.parse(state);

    // Existing code that updates/re-renders the cart

    window.syncBundleGifts?.();
  })
})
}

function deleteItemFromCart (itemId) {
  let addData = {
    updates: {}
  }

  addData.updates[itemId] = 0

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(addData)
  })
  .then((response) => {
    if (response.status === 200) {
      document.dispatchEvent(new Event('cart:build'))
    }
  })
  .catch((error) => {
    console.log('catch: deleteItemFromCart', error)
  })
}

function openSortByDrawer (el) {
  let waitTime = window.pageYOffset < 300 ? 400 : 0
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  let elTop = document.querySelector('.collection-content').getBoundingClientRect().top
  let scrollTo = elTop + scrollTop
  window.scrollTo({ top: scrollTo, behavior: 'smooth' })
  setTimeout(() => {
    let sortBy = document.querySelector('.collection-mobile-sort_by')
    sortBy.classList.toggle('is-active')
    let filterBtn = document.querySelector('.collection-filter__btn')
    filterBtn.classList.toggle('collection-filter__btn--disabled')
    let arrowSort = el.querySelector('svg')
    arrowSort.classList.toggle('is-active')
  }, waitTime)
}

function clearFilters (collectionUrl) {
  localStorage.removeItem('filter_query_string')
  document.location.href = collectionUrl
}

function addBundle (productId, quantitySelector, productListId) {
  let variantsTitle = []
  let variantsId = []
  // get all options (variants) for products inside the bundle
  let productsInBundle = document.querySelectorAll('#productsInBundle li')
  productsInBundle.forEach(product => {
    // get all options
    let auxProductId = product.getAttribute('product-id')
    let auxOptions = product.querySelectorAll('select')
    let options = []
    auxOptions.forEach(elem => {
      options.push(elem.value)
    })

    // find the product on the array bundlesVariantsOptions to get the variant id
    let variantInfo = bundlesVariantsOptions.find(elem => elem.id == auxProductId)

    let variantTitle = ''
    if (variantInfo) {
      let auxVariant = null
      variantInfo.options.forEach((elem, index) => {
        if (auxOptions.length == 2) {
          if ((elem.option1 == options[0] && elem.option2 == options[1]) || (elem.option2 == options[0] && elem.option1 == options[1])) {
            auxVariant = elem.variantId
            variantTitle = `${variantTitle}: ${elem.option1} / ${elem.option2}`
          }
        } else if (auxOptions.length == 1) {
          if (elem.option1 == options[0] || elem.option2 == options[0]) {
            auxVariant = elem.variantId
            variantTitle = `${variantTitle}: ${elem.option1} ${elem.option2}`
          }
        } else {
          auxVariant = elem.variantId
          variantTitle = `${variantTitle}`
        }
      })

      // we have the variant id, now we can store it on the object
      variantsTitle.push(`${variantInfo.title} ${variantTitle}`)
      variantsId.push(auxVariant)
    }
  })

  // get quantity, check if comes from modal
  let tempQuantity = document.querySelector(`#${quantitySelector}`) ? document.querySelector(`#${quantitySelector}`).value : null
  if (tempQuantity == null) {
    tempQuantity = document.querySelector(`#${quantitySelector}-modal`) ? document.querySelector(`#${quantitySelector}-modal`).value : '0'
  }

  const data = {
    'items': [{
      'id': productId,
      'quantity': Number(tempQuantity),
      'properties': {
        'bundleid': `${productId}-${getRandom()}`,
        '_productListTitle': variantsTitle.join(','),
        '_productListId': variantsId.join(',')
      }
    }]
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => {
      if (data.status === 422 || data.status === 'bad_request') {
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'))
      }
    })
}

function openAlert (message, delaytime = 2000) {
  $('#alert-add').html(message)
  $('#alert-add').animate({ bottom: '100px' }, 500)

  setTimeout(() => {
    $('#alert-add').animate({ bottom: '-200px' }, 1000)
  }, delaytime)
}

async function cleanupBundlesFromCart () {
  await removeBundleProductsFromCart()
}

function deleteInternalBundle (bundleId, position) {
  let currentBundles = localStorage.getItem('bundles')
  currentBundles = JSON.parse(currentBundles)
  currentBundles.bundles.splice(position, 1)
  localStorage.setItem('bundles', JSON.stringify(currentBundles))
  document.dispatchEvent(new Event('cart:build'))
}

function quantityInternalBundle (minusPlus, position) {
  let currentBundles = localStorage.getItem('bundles')
  currentBundles = JSON.parse(currentBundles)
  if (Number(currentBundles.bundles[position].quantity) + minusPlus > 0) {
    currentBundles.bundles[position].quantity = Number(currentBundles.bundles[position].quantity) + minusPlus
  } else {
    currentBundles.bundles.splice(position, 1)
  }
  localStorage.setItem('bundles', JSON.stringify(currentBundles))
  document.dispatchEvent(new Event('cart:build'))
}

function getRandom () {
  let min = 1
  let max = 1000
  return Math.round(Math.random() * (max - min) + min)
}

// if there is bundles then add to the cart and redirect to checkout
async function preCheckoutCart () {
  document.querySelector('.cart__checkout').classList.add = 'btn--loading'
  let currentBundles = document.querySelectorAll('.cart__item')
  let productsToAdd = []
  let bundlesToDelete = []

  let data2 = {
    updates: {}
  }

  if (currentBundles) {
    currentBundles.forEach(oneBundle => {
      let tempVariant = oneBundle.getAttribute('variants-list')
      if (tempVariant.length) {
        let auxList = tempVariant.split(',')
        // add to the cart all products inside the bundle
        auxList.forEach(oneVariant => {
          if (oneVariant.length) {
            let productData = {
              'id': oneVariant,
              'quantity': Number(oneBundle.querySelector('.cart__adjust-quantity').value),
              'properties': {
                '_isbundle': true,
                '_bundle': oneBundle.getAttribute('product-id')
              }
            }
            productsToAdd.push(productData)
          }
        })
        // then remove the bundle product
        data2.updates[`${oneBundle.getAttribute('data-key')}`] = 0

        // add bundle info to localstorage to restore it after if the customer go back from checkout
        let auxBundleInfo = {
          bundleId: oneBundle.getAttribute('product-id'),
          productListTitle: oneBundle.getAttribute('variants-list-title'),
          productListId: oneBundle.getAttribute('variants-list'),
          quantity: oneBundle.querySelector('.cart__adjust-quantity').value
        }
        let auxLocal = localStorage.getItem('bundles-info')
        if (auxLocal) {
          auxLocal = JSON.parse(auxLocal)
          // check if the bundle id exists
          let auxBundle = auxLocal.find(elem => elem.bundleId == auxBundleInfo.bundleId)
          if (!auxBundle) {
            auxLocal.push(auxBundleInfo)
            localStorage.setItem('bundles-info', JSON.stringify(auxLocal))
          }
        } else {
          localStorage.setItem('bundles-info', JSON.stringify([auxBundleInfo]))
        }
      }
    })

    let data = {
      items: productsToAdd
    }

    if (data && data.items.length) {
      await callToCart(data, '/cart/add.js')
    }

    if (data2 && !jQuery.isEmptyObject(data2.updates)) {
      await callToCart(data2, '/cart/update.js')
    }
    document.location.href = '/checkout'
  }
}

function callToCart (data, url) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => {
      if (data.status === 422 || data.status === 'bad_request') {
        openAlert(data.description)
      }
    })
}

// to do
// if customer come back from checkout, remove bundle internal cart items
function removeBundleProductsFromCart () {
  let uniqueBundleId = []
  let productsToRemove = {
    updates: {}
  }
  let bundleFound = false

  // get products inside bundle to remove
  let individualProducts = document.querySelectorAll('.for-bundle')

  individualProducts.forEach(oneProduct => {
    productsToRemove.updates[oneProduct.getAttribute('data-key')] = 0
    bundleFound = true
    // check if the bundle id exists in array
    uniqueBundleId.push(oneProduct.getAttribute('bundle-id'))
  })

  if (bundleFound) {
    uniqueBundleId = [... new Set(uniqueBundleId)]
    cleanCart(productsToRemove, uniqueBundleId)
  }
}

async function cleanCart (productsToRemove, uniqueBundleId) {
  // remove individual items
  await callToCart(productsToRemove, '/cart/update.js')

  // add original bundles from localStorage
  let auxBundles = localStorage.getItem('bundles-info')

  let data = {
    items: []
  }

  if (auxBundles) {
    let auxBundlesInfo = JSON.parse(auxBundles)
    uniqueBundleId.forEach(oneBundle => {
      let foundBundle = auxBundlesInfo.find(bundle => bundle.bundleId === oneBundle)
      if (foundBundle) {
        data.items.push(
          {
            'id': foundBundle.bundleId.split('-')[0],
            'quantity': foundBundle.quantity,
            'properties': {
              'bundleid': foundBundle.bundleId,
              '_productListTitle': foundBundle.productListTitle,
              '_productListId': foundBundle.productListId,
            }
          }
        )
      }
    })

    await callToCart(data, '/cart/add.js')
  }
  document.dispatchEvent(new Event('cart:build'))
}

function goToAnchor (element) {
  let yOffset = -70
  const el = document.querySelector(`${element}`);
  const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({ top: y, behavior: 'smooth' });
}

function openNewsletterPopup() {
  let temp = new theme.Modals('NewsletterPopup-newsletter-popup', 'newsletter-popup-modal')
  temp.open()
}

// buy it with on mobile
function buyItWithMobile (element) {
  if (window.innerWidth <= 768) {
    const productHandle = element.getAttribute('data-handle');
    console.log("🚀 ~ file: theme.js:2284 ~ productHandle", productHandle)
    window.location.href = `/products/${productHandle}`;
  }
}

// @todo: Task put into icebox, check with designer
// function handleHeroText () {
//   let heroBannerTop = 0
//   document.addEventListener('scroll', () => {
//     const heroBanner = document.querySelector('.hero-banner__content')
//     heroBannerTop = heroBanner.getBoundingClientRect().top > 0 ? heroBanner.getBoundingClientRect().top : heroBannerTop
//     if (window.scrollY >= heroBannerTop) {
//       heroBanner.style = 'opacity: 0; pointer-events: none;'
//     } else {
//       heroBanner.style = 'opacity: 1; pointer-events: all;'
//     }
//   })
// }

// handleHeroText()
